/**
 * FramesOptionsBottom — Bottom Sheet para Mobile (≤ 850px)
 */
import { useEffect, useRef } from "react";
import { Pencil, X } from "lucide-react";
import { Frame } from "../../../types";
import FramesOptionsContent from "./frames-options-content";
import BottomSheet from "../../../global-components/bottom-sheet/bottom-sheet";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../global-components/src";
import { useTranslation } from "react-i18next";

interface FramesOptionsBottomProps {
    frame?: Frame | null;
    open: boolean;
    setOpen: (open: boolean) => void;
}

const FramesOptionsBottom: React.FC<FramesOptionsBottomProps> = ({ frame, open, setOpen }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const { user, isSuper } = useAuth();
    const canAdmin = user?.permissions?.includes("create_frame") || isSuper();
    const navigate = useNavigate();

    useEffect(() => {
        if (open) setOpen(false);
    }, [location.pathname]);

    return (
        <BottomSheet disableDrag snapPoints={[0, 1]} open={open} setOpen={setOpen}>
            <div className="foc-sheet-content">
                <div className="foc-sheet-header">
                    <h4 className="foc-sheet-title">{t("frames.frame")}</h4>

                    <div className="d-flex" style={{ gap: 5 }}>
                        {canAdmin && (
                            <button type="button" className="foc-edit-btn" onClick={() => navigate(`/molduras/${frame?.id}`)} title={t("frames.editFrame")}>
                                <Pencil size={15} />
                            </button>
                        )}
                        <button
                            type="button"
                            className="foc-sheet-close"
                            onClick={() => setOpen(false)}
                            aria-label={t("frames.close")}
                        >
                            <X size={16} />
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="foc-sheet-body">
                    <FramesOptionsContent
                        open={open}
                        frame={frame}
                        onClose={() => setOpen(false)}
                    />
                </div>
            </div>
        </BottomSheet>
    );
};

export default FramesOptionsBottom;